<ion-content class="ion-text-center modal">
  <rc-modal-header></rc-modal-header>
  <rc-rack-scanner (onQrCodeScanned)="handleQrCodeScanned($event)"></rc-rack-scanner>
</ion-content>
